/* eslint-disable react/require-default-props */
import React from 'react';
import AiManagementSummaryCard from 'components/atoms/ai_management_summary_card';
import AiManagementCollapsibleCard from 'components/molecules/ai_management_collapsible_card';
import AiManagementDataCard from 'components/molecules/ai_management_data_card';
import {
  PossibleCompetitorSize,
  PossibleCompetitorSizeYear,
} from 'services/actions/ai_management_possible_competitors';
import { EMPTY_VALUE, money } from 'services/ai_management_format';
import { Content } from './styles';

interface AiManagementCompetitorSizeProps {
  size: PossibleCompetitorSize;
  className?: string;
  onOpenContracts?: () => void;
}

const MONTHS = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

export const sizePeriod = (year: PossibleCompetitorSizeYear) => {
  if (year.completo) return 'ano completo';
  const month = year.ate_mes ? MONTHS[year.ate_mes - 1] : null;
  return month ? `até ${month}` : 'ano parcial';
};

const AiManagementCompetitorSize: React.FC<AiManagementCompetitorSizeProps> = ({
  size,
  className = '',
  onOpenContracts,
}) => {
  const years = Array.from(
    new Set([...size.adjudicados, ...size.contratados].map((year) => year.ano)),
  ).sort((a, b) => a - b);

  return (
    <AiManagementCollapsibleCard title="Porte" className={className}>
      {size.texto ? (
        <AiManagementSummaryCard className="mb-3">{size.texto}</AiManagementSummaryCard>
      ) : null}

      <AiManagementDataCard compact>
        <Content className="table-responsive">
          <table className="table bg-white mb-0">
            <thead className="thead-light">
              <tr>
                <th scope="col">Ano</th>
                <th scope="col" className="text-center text-nowrap">
                  Valor adjudicado
                </th>
                <th scope="col" className="text-center text-nowrap">
                  Valor contratado
                </th>
                <th scope="col" className="text-center text-nowrap">
                  Situação do limite ME/EPP
                </th>
              </tr>
            </thead>
            <tbody>
              {years.length ? (
                years.map((ano) => {
                  const awarded = size.adjudicados.find((year) => year.ano === ano);
                  const contracted = size.contratados.find((year) => year.ano === ano);
                  const period = contracted ?? awarded;
                  return (
                    <tr key={ano}>
                      <td>
                        <div className="size-year">{ano}</div>
                        {period ? <div className="text-muted">{sizePeriod(period)}</div> : null}
                      </td>
                      <td className="text-center text-nowrap">
                        {awarded ? money(awarded.valor) : EMPTY_VALUE}
                      </td>
                      <td className="text-center text-nowrap">
                        {contracted ? money(contracted.valor) : EMPTY_VALUE}
                      </td>
                      <td className="text-center">
                        {contracted ? (
                          <span
                            className={`badge ${
                              contracted.acima_limite ? 'badge-danger' : 'badge-success'
                            }`}
                          >
                            {contracted.acima_limite ? 'Acima do limite' : 'Dentro do limite'}
                          </span>
                        ) : (
                          <span className="text-muted">{EMPTY_VALUE}</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="text-muted">
                    Nenhum valor adjudicado ou contratado por ano.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Content>
      </AiManagementDataCard>

      {onOpenContracts ? (
        <button type="button" className="btn btn-outline-primary mt-3" onClick={onOpenContracts}>
          Ver contratos
        </button>
      ) : null}
    </AiManagementCollapsibleCard>
  );
};

export default AiManagementCompetitorSize;
